import api from '@/libs/axios'

const endpoint = '/export_history'

const service = {
    getAll: async (params) => {
        try {
            const result = await api.get(endpoint, {
                params
            })
            return result.data
        } catch {
            return null
        }
    },
    download: async (id) => {
        try {
            const result = await api.get(`${endpoint}/${id}/download`)
            return result.data
        } catch {
            return null
        }
    }
}

export { service }
